import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createReducer } from 'utils'

import { FETCH_STATUSES } from 'resources'

import { RESET } from './types'
import actions from './actions'
import constants from './constants'

export const initialState = {
  buttonLabel: null,
  error: {},
  isOpenModal: false,
  modalTitle: null,
  modalMessage: null,
  region: null,
  status: constants.NOOP,
  isAuthenticatedRoute: null,
  regionCheckStatus: FETCH_STATUSES.NOOP,
  ipAddress: null,
  isNoInternetError: false,
  enableReferral: false,
  redemptionShareCaption: '',
  referrerBonusLimit: 0,
  referralBonusAmount: 0,
  referralRewardsRatio: 0,
  isSecureConstantsFetched: constants.NOOP,
  redemptionMinBalance: null,
  redemptionMinRequestInterval: null,
  redemptionMinAccountAge: null,
  redemptionOptionsHelpLink: null,
  accountStatusHelpLink: null,
  intercomUserHashWeb: null,
  regionErrorResponse: null,
  pointsMultiplier: 1,
  enableBitcoin: false,
  enableEthereum: false,
  enableUsdc: false,
  polygonLearnMoreUrl: '',
  sharesForRedemptionState: '',
  sharesRequiredQuestionLabels: [],
  sharesHoldProcessExplanation: null,
  sharesAutoRedeemExplanationLink: '',
  weeklyPaycheckDay: 3,
  subscriptionBasicVerifiedIdLimit: 0,
  subscriptionLiteVerifiedIdLimit: 0,
  subscriptionProVerifiedIdLimit: 0,
}

const ActionReducer = createReducer(initialState, {
  [actions.showGeneralModal.SUCCESS_TYPE]: (state, payload) => ({
    ...state,
    isOpenModal: true,
    modalTitle: payload.modalTitle,
    modalMessage: payload.modalMessage,
    buttonLabel: payload.buttonLabel,
  }),
  [actions.hideGeneralModal.SUCCESS_TYPE]: (state) => ({
    ...state,
    buttonLabel: null,
    error: {},
    isOpenModal: false,
    modalTitle: null,
    modalMessage: null,
  }),
  [actions.initApp.INIT_TYPE]: (state) => ({
    ...state,
    status: constants.INITIALIZING,
  }),
  [actions.initApp.SUCCESS_TYPE]: (state) => ({
    ...state,
    status: constants.INITIALIZED,
  }),
  [actions.initApp.FAILURE_TYPE]: (state) => ({
    ...state,
    status: constants.INITIALIZATION_FAILED,
  }),
  [actions.setRegion.SUCCESS_TYPE]: (state, { region }) => ({
    ...state,
    region,
    isNoInternetError: false,
    regionCheckStatus: FETCH_STATUSES.SUCCESS,
  }),
  [actions.setRegion.FAILURE_TYPE]: (state, { responseJson, isNoInternetError }) => {
    const { region, ipAddress } = responseJson
    return {
      ...state,
      region,
      ipAddress,
      regionCheckStatus: FETCH_STATUSES.FAILURE,
      isNoInternetError,
    }
  },
  [actions.setIsAuthenticatedRoute.SUCCESS_TYPE]: (state, { isAuthenticatedRoute }) => ({
    ...state,
    isAuthenticatedRoute,
  }),
  [actions.setIpAddress.SUCCESS_TYPE]: (state, { ipAddress }) => ({
    ...state,
    ipAddress,
  }),
  [actions.fetchSecureConstants.SUCCESS_TYPE]: (
    state,
    {
      redemptionShareCaption,
      referrerBonusLimit,
      referralRewardsRatio,
      redemptionMinBalance,
      redemptionMinRequestInterval,
      redemptionMinAccountAge,
      redemptionOptionsHelpLink,
      accountStatusHelpLink,
      enableBitcoin,
      enableEthereum,
      enableUsdc,
      polygonLearnMoreUrl,
      sharesForRedemptionState,
      sharesRequiredQuestionLabels,
      sharesHoldProcessExplanation,
      sharesAutoRedeemExplanationLink,
      weeklyPaycheckDay,
      subscriptionBasicVerifiedIdLimit,
      subscriptionLiteVerifiedIdLimit,
      subscriptionProVerifiedIdLimit,
    },
  ) => ({
    ...state,
    redemptionShareCaption,
    referrerBonusLimit,
    isSecureConstantsFetched: constants.SECURE_CONSTANTS_FETCHED,
    redemptionMinBalance,
    redemptionMinRequestInterval,
    redemptionMinAccountAge,
    redemptionOptionsHelpLink,
    accountStatusHelpLink,
    referralRewardsRatio,
    enableBitcoin,
    enableEthereum,
    enableUsdc,
    polygonLearnMoreUrl,
    sharesForRedemptionState,
    sharesRequiredQuestionLabels,
    sharesHoldProcessExplanation,
    sharesAutoRedeemExplanationLink,
    weeklyPaycheckDay,
    subscriptionBasicVerifiedIdLimit,
    subscriptionLiteVerifiedIdLimit,
    subscriptionProVerifiedIdLimit,
  }),
  [actions.fetchConstants.SUCCESS_TYPE]: (state, { enableReferral, referralBonusAmount, pointsMultiplier }) => ({
    ...state,
    enableReferral,
    referralBonusAmount,
    pointsMultiplier,
  }),
  [actions.fetchIntercomUserHash.SUCCESS_TYPE]: (state, { intercomUserHashWeb }) => ({
    ...state,
    intercomUserHashWeb,
  }),
  [RESET]: () => initialState,
})

const persistConfig = {
  key: 'general',
  storage,
  whitelist: [
    'intercomUserHashWeb',
    'enableReferral',
    'referralBonusAmount',
    'referralRewardsRatio',
    'pointsMultiplier',
  ],
}

export default persistReducer(persistConfig, ActionReducer)
